<template>
  <div v-if="showModalInfo.isShow" class="box">
    <div class="mask"/>
    <div class="content">
      <div class="title">{{showModalInfo.title}}</div>
      <div class="over-div">
        <div class="text">{{showModalInfo.content}}</div>
      </div>
      <div class="line"/>
      <div class="btn-content">
        <div class="btn" @click="clickCancel">
          <div class="cancel-text">取消</div>
        </div>
        <div class="btn" @click="sureClick">
          <div class="sure-text">{{showModalInfo.confirmText}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    // 弹窗信息
    showModalInfo: {
      type: Object,
      default: (() => {}),
    },
  },

  methods: {
    // 点击确定
    sureClick() {
      if (this.showModalInfo?.link) {
        const webPlatf = multi.$system.webPlatform;
        if (webPlatf === 'wxmp') {
          // eslint-disable-next-line no-undef
          wx.miniProgram.navigateTo({
            url: this.showModalInfo?.link,
          });
        }
      }
    },

    // 点击取消
    clickCancel() {
      const webPlatf = multi.$system.webPlatform;
      if (webPlatf === 'wxmp') {
        // eslint-disable-next-line no-undef
        wx.miniProgram.switchTab({
          url: '/pages/home/index',
        });
      }
    },
  },

};
</script>

<style lang="less" scoped>
.box {
  width: 100%;
  flex: 1;
  display: flex;
  background-color: rgba(0, 0, 0, 0.7);
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10000000;
}

.content{
  width: 560px;
  align-items: center;
  background: #ffffff;
  border-radius: 24px;
  overflow: hidden;
  margin-top: -200px;
}

.title{
  font-family: PingFang-SC-Bold;
  font-size: 36px;
  color: #000000;
  text-align: center;
  line-height: 54px;
  font-weight: 700;
  margin-top: 48px;
}

.input_content{
  margin-top: 40px;
  width: 480px;
  align-items: center;
  justify-content: center;
}

.line{
  width: 560px;
  height: 1px;
  background: #EEEEEE;
}

.btn-content{
  width: 560px;
  height: 112px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background: #EEEEEE;
}

.btn{
  width: 279px;
  height: 112px;
  display: flex;
  background: #ffffff;
  align-items: center;
  justify-content: center;
}

.cancel-text{
  font-family: PingFangSC-Regular;
  font-size: 34px;
  color: #000000;
  text-align: center;
  line-height: 34px;
  font-weight: 400;
}

.sure-text{
  font-family: PingFangSC-Regular;
  font-size: 34px;
  color: #FF4400;
  text-align: center;
  line-height: 34px;
  font-weight: 400;
}

.text {
  padding: 24px 56px 48px  56px;
  font-family: PingFang-SC-Regular;
  font-size: 32px;
  color: #000000;
}

</style>
